import { useTheme } from '@mui/material'
import { getLucidePaths } from '../utilities/lucide'
import arrowUpRight from 'lucide-static/icons/arrow-up-right.svg?raw'
import terminal from 'lucide-static/icons/terminal.svg?raw'
import IconPlus from './IconPlus'

interface Props extends React.SVGProps<SVGSVGElement> {
  plus?: boolean
  outline?: boolean
  type: ServiceType
}

export default function IconService({ plus, outline, type, ...props }: Readonly<Props>) {
  const { palette } = useTheme()

  return (
    <svg width="38" height="38" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {type === 'web' ? (
        <circle
          cx="14"
          cy="14"
          r="12"
          fill={palette.secondary.main}
          stroke={palette.background.default}
          vectorEffect="non-scaling-stroke"
          strokeWidth={outline ? 2 : 0}
        />
      ) : (
        <rect
          x="3"
          y="3"
          width="22"
          height="22"
          rx="2"
          ry="2"
          fill={palette.secondary.main}
          stroke={palette.background.default}
          vectorEffect="non-scaling-stroke"
          strokeWidth={outline ? 2 : 0}
        />
      )}
      {plus ? (
        <IconPlus color={palette.secondary.contrastText} />
      ) : (
        <g transform="translate(8, 8) scale(0.5)">
          <g
            stroke={palette.secondary.contrastText}
            fill="none"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          >
            {getLucidePaths(type === 'web' ? arrowUpRight : terminal)}
          </g>
        </g>
      )}
    </svg>
  )
}
